// config.js

const bizIcon = 'https://images.marketleader.com/Logos/00/920500_normal.jpg';
const myBizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const imageOne = "https://media.istockphoto.com/id/1339743146/photo/aerial-view-of-leafy-eastern-suburb-houses-either-side-of-t-intersection-in-adelaide-south.jpg?s=612x612&w=0&k=20&c=lnNAEBQ7wQ2eDdpGWUJH13LVd_g2TE7ZO41yI0QkCmw=";
const imageTwo = "https://images.marketleader.com/HouseImages/CINCINNATI/517/1759517.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f";
const imageThree = "https://images.marketleader.com/HouseImages/CINCINNATI/489/1601489.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f";
const imageFour = "https://media.istockphoto.com/id/2169660961/photo/road-building-with-backhoe-works-excavator-with-heavy-back-hoe-working-on-construction-site.jpg?s=612x612&w=0&k=20&c=RdeYVuICiIU-buuVgOsN4K_eNE-NJZoeFxypQWKpidA=";
const imageFive = "https://images.marketleader.com/MarketingImages/50/2404150_normal.jpg";

const redirectLink = "https://www.sellyourcincyhome.com/";

export const siteConfig = {
  title: "Warren Kimbrough OwnerLand Realty",
  metaDescription: "Warren Kimbrough OwnerLand Realty",
  theme: {
    primaryColor: "red-600",
    secondaryColor: "gray-900",
    accentColor: "text-red-600"
  },
  logo: {
    src: bizIcon,
    alt: "Warren Kimbrough OwnerLand Realty Icon",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Warren Kimbrough OwnerLand Realty",
    headline: "Your Trusted Real Estate Agent in West Chester, OH",
    address: "OwnerLand Realty, 9078 Union Centre Blvd, West Chester, OH 45069",
    description: `
      Welcome to Warren Kimbrough OwnerLand Realty. With a wealth of knowledge about local communities, current market trends, and the intricacies of the home buying and selling process, Warren is committed to delivering a seamless and exceptional real estate experience. 
    `,
  },
  images: {
    business: {
      src: imageOne,
      alt: "Your Trusted Real Estate Agent in West Chester, OH",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description: 
        "Local Expertise: Warren knows West Chester, OH, and surrounding communities inside and out. He helps you find the perfect home at the right price, including all the neighborhood amenities that matter most to you.",
    },
    {
      description: 
        "Selling Your Home: Warren offers comprehensive marketing strategies, finds the right buyers, negotiates on your behalf, oversees inspections, and manages all the necessary paperwork for a smooth and successful sale.",
    },
    {
      description: 
        "Tailored Guidance: Whether you’re buying or selling, Warren provides expert advice, ensuring you make the best possible decisions for your real estate goals. Timing is everything—let's achieve your dreams together!",
    },
  ],  
  services: {
    sectionTitle: "Recent Sales",
    description: 
      "Take a look at Warren's recent real estate transactions, showcasing his expertise in finding and selling properties that meet his clients' needs and expectations. From cozy family homes to prime investment opportunities, Warren brings results.",
    callouts: [
      {
        name: "705 Clinton Ave, Hamilton, OH, 45015",
        description: 
          "Sold for $114,900. This charming 3-bed, 2-bath, 1165 sq ft home is another example of Warren's dedication to delivering client satisfaction.",
        imageSrc: imageThree,
        imageAlt: "Picture of 705 Clinton Ave, Hamilton, OH, 45015.",
      },
      {
        name: "1507 Netherland Court, Forest Park, OH, 45240",
        description: 
          "Sold for $130,000. This 3-bed, 2-bath, 1364 sq ft property showcases Warren's ability to connect buyers with their ideal home in Forest Park.",
        imageSrc: imageTwo,
        imageAlt: "Picture of 1507 Netherland Court, Forest Park, OH, 45240.",
      },
      {
        name: "705 Clinton Ave, Hamilton, OH, 45015",
        description: 
          "Sold for $114,900. This charming 3-bed, 2-bath, 1165 sq ft home is another example of Warren's dedication to delivering client satisfaction.",
        imageSrc: imageThree,
        imageAlt: "Picture of 705 Clinton Ave, Hamilton, OH, 45015.",
      },
    ],
  },  
  about: {
    sectionTitle: "About Us",
    description:   
      "I'm Warren Kimbrough, your trusted real estate professional at OwnerLand Realty in West Chester, OH. With designations like ABR, RENE, NCBS, and QSM, I bring industry-leading expertise to the table, ensuring every transaction is smooth and stress-free.",
    image: {
      src: imageFive,
      alt: "Warren Kimbrough providing expert real estate services in West Chester, OH.",
      width: 1200,
      height: 800,
    },
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "OwnerLand Realty, 9078 Union Centre Blvd, West Chester, OH 45069",
    googleMapsEmbedUrl: 
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3111.565123456789!2d-84.4527956848827!3d39.34385678142708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8840522be64d3c57%3A0xabcdef123456789!2s9078%20Union%20Centre%20Blvd%2C%20West%20Chester%2C%20OH%2045069%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=9078+Union+Centre+Blvd,+West+Chester,+OH+45069,+USA',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=9078+Union+Centre+Blvd,+West+Chester,+OH+45069,+USA&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/9078+Union+Centre+Blvd,+West+Chester,+OH+45069,+USA/@39.343857,-84.452796,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/9078+Union+Centre+Blvd,+West+Chester,+OH+45069,+USA/@39.343857,-84.452796,15z',
      },
    ],
  },  
  contact: {
    sectionTitle: "Contact Warren Kimbrough",
    description: 
      "Whether you're buying, selling, or exploring your options, Warren is here to help. Reach out for personalized real estate advice and expert guidance.",
    socialLinks: {
      facebook: redirectLink,     
      instagram: redirectLink,     
      twitter: redirectLink,     
      linkedin: redirectLink,     
      youtube: redirectLink,     
    },
    contactNumbers: [
      "Mobile: 513-708-8955",
      "Office:  513-667-8991"
    ],
    logo: bizIcon,
    emailRecipient: "wejk1@hotmail.com"
  },
  footer: {
    bizSolutionsLogo: myBizIcon
  }
};


